const API_BASE_URL="https://musicshare-dusky.vercel.app/api/v1"
const SITE_URL = "https://music-ten-rho.vercel.app"

//Local server
// const API_BASE_URL = "http://localhost:3001/api/v1";
//const SITE_URL="http://localhost:3000"

const credentials = {
  appName: "Bliss Distro",
  appShortDesc: "Getting your music to the listeners",
  email: "blisshype.com@gmail.com",
  BASE_URL:API_BASE_URL,
  musicImage_URL:`${API_BASE_URL}/music/cover/image/view`,
  musicStream_URL:`${API_BASE_URL}/music/stream/music`,
  download_URL:`${API_BASE_URL}/music/download`,
  SITE_URL
};

export default credentials